import React from 'react';
import { useTranslation } from 'react-i18next';
import './Loader.scss';

interface LoaderProps {
  message?: string;
}

export const Loader: React.FC<LoaderProps> = ({ message }) => {
  const { t } = useTranslation();
  const displayMessage = message ?? t('loading');

  return (
    <bds-grid class="loader-container">
      <bds-grid class="spinner" />
      <bds-typo class="loading-text">{displayMessage}</bds-typo>
    </bds-grid>
  );
};